import React from 'react';
import { Container } from '@mui/material';
import Pronunciations from './Pronunciations';

function App() {
  return (
    <React.Fragment>
      <Container>
        <Pronunciations />
      </Container>
    </React.Fragment>
  );
}

export default App;
